<template>
  <div v-if="visual.showModal" class="modal-container">
    <div v-bind:class="{'open' : visual.showModal}" class="popup-module-wrapper always-centered">
      <div class="popup-module">
        <div class="row">
          <div class="col-xs-12">
              <div v-bind:class="{'fadein-sequence' : visual.showModal}">
                <a href="#" class="modal-close fadein-1" @click="modalToggle()">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.94922 4.94922L14.8487 14.8487" stroke="#001965" stroke-width="2"/>
                <path d="M4.94922 14.8496L14.8487 4.95011" stroke="#001965" stroke-width="2"/>
                </svg>
              </a>
                <div class="headline">{{ d.modalheadline }}</div>
                <div class="">
                  <div class="modal-rte" v-html="d.modaltext"></div>
                </div>
                <div class="center-md">
                    <button href="#" class="button primary" @click="modalToggle()" >{{d.modalbutton}}</button>
                </div>
              </div>
          </div>
        </div>
        
      </div>
    </div>
  </div>

  <div v-if="visual.showEducationProblemModal" class="modal-container">
    <div v-bind:class="{'open' : visual.showEducationProblemModal}" class="popup-module-wrapper always-centered">
      <div class="popup-module">
        <div class="row">
          <div class="col-xs-12">
              <div v-bind:class="{'fadein-sequence' : visual.showEducationProblemModal}">
                <a href="#" class="modal-close fadein-1" @click="modalEducationToggle()">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.94922 4.94922L14.8487 14.8487" stroke="#001965" stroke-width="2"/>
                <path d="M4.94922 14.8496L14.8487 4.95011" stroke="#001965" stroke-width="2"/>
                </svg>
              </a>
                <div class="fadein-1 headline">{{ d.erroreducationdurationnotcompatiblewithinsuranceTitle }}</div>
                <div class="fadein-2">
                  <div class="modal-rte" v-html="d.erroreducationdurationnotcompatiblewithinsurance"></div>
                </div>
                <div class="fadein-2 center-md">
                    <button href="#" class="button primary" @click="modalEducationToggle()" >{{d.modalbutton}}</button>
                </div>
              </div>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</template>
<script>
export default {
props: {
  text: String
},
data: (instance) => {
  return {
    values: instance.store[instance.store.currentCulture].values.personalDetails,
        product: instance.store[instance.store.currentCulture].values.productDetails,
        d: instance.store[instance.store.currentCulture].dictionary,
        culture: instance.store.currentCulture,
        visual: instance.store[instance.store.currentCulture].values.visualDetails,

  }
},
methods: {
  modalToggle() {
    this.visual.showModal = false;
  },
  modalEducationToggle() {
    this.visual.showEducationProblemModal = false;
  }
}
};
</script>
<style scoped lang="postcss">
.popup-module-wrapper {
  z-index: 101;
  .popup-module {
    transform: translateX(-5%);
    padding-top: 60px;

    .headline {
      font-weight: bold;
      margin-bottom: .5rem;
    }

    .modal-close {
      position: absolute;
      top: 15px;
      right:15px;

      svg {
        width: 25px;
        height: 25px;
      }
    }
  }
  .modal-rte {
    margin-bottom: 1rem;
  }
}
</style>